import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppHttpService } from "@core";
import { TableWordNoun, TableWordVerb } from "@model";

@Injectable({ providedIn: "root" })
export class TablesHttpService {
  constructor(private _appHttpService: AppHttpService) {}

  loadTableWordNoun(lemma: string): Observable<TableWordNoun> {
    const url = "/api/get-table-word-noun";
    const params = { lemma };

    return this._appHttpService.makeGETRequest<TableWordNoun>(url, params, [404]);
  }

  loadTableWordVerb(lemma: string): Observable<TableWordVerb> {
    const url = "/api/get-table-word-verb";
    const params = { lemma };

    return this._appHttpService.makeGETRequest<TableWordVerb>(url, params, [404]);
  }
}
